<template>
  <div>
    <el-card class="mb10">
      <el-form size="small" label-width="60px">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="cnpj：">
              <el-input v-model="queryForm.params.cnpj" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--查询-->
            <el-button
              type="primary"
              icon="el-icon-search"
              size="mini"
              @click="search"
            >{{ $t('basicData.Search') }}
            </el-button>
            <!--重置-->
            <el-button
              icon="el-icon-refresh"
              size="mini"
              @click="onReset"
            >{{ $t('basicData.reset') }}
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card>
      <el-table
        :data="tableData"
        border
        class="table-height"
        :header-cell-style="{background:'#f2f2f2',color:'black'}"
        :height="tableHeightRow.height"
      >
        <el-table-column
          :label="$t('GlobalSetObj.serial')"
          align="center"
          type="index"
          width="80"
          fixed="left"
        />
        <!-- 开票时间 -->
        <el-table-column prop="cnpj" label="cnpj" min-width="160" />
        <!-- 响应数据 -->
        <el-table-column
          prop="responseData"
          :label="$t('mdfeTranslate.responseData')"
          min-width="200"
          :show-overflow-tooltip="false"
        >
          <template v-slot="scope">
            <el-tooltip placement="top">
              <pre slot="content" style="max-height: 400px; overflow: auto">
                {{ scope.row.responseDataNew }}
              </pre>
              <div class="paramsStyle">{{ scope.row.responseData }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="updateUser"
          :label="$t('GlobalSetObj.Updater')"
          min-width="100"
        >
          <template v-slot="scope">
            {{ createUser[scope.row.updateUser] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="updateTime"
          :label="$t('GlobalSetObj.UpdateTime')"
          min-width="180"
        />
        <el-table-column
          :label="$t('GlobalSetObj.operate')"
          width="80"
          align="center"
          fixed="right"
        >
          <template v-slot="scope">
            <el-popover
              placement="bottom"
              trigger="click"
            >
              <el-button slot="reference" size="small" type="text"><i class="el-icon-more" style="font-size: 26px" /></el-button>
              <div style="margin: 5px">
                <!--更新cnpj信息-->
                <el-button
                  type="primary"
                  size="mini"
                  @click="updateInformation(scope.row)"
                >{{ $t('mdfeTranslate.UpdateCnpjInformation') }}
                </el-button>
              </div>
              <!--获取最新信息-->
              <div style="margin: 5px">
                <el-button
                  size="mini" type="primary"
                  @click="getNewInformation(scope.row)"
                >{{ $t('mdfeTranslate.GetLatestInformation') }}</el-button>
              </div>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="queryForm.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="queryForm.pageSize"
          :total="total"
          background
          style="margin: 10px 0"
          @current-change="getCurrentTable"
          @size-change="getSizeTable"
        />
      </div>
    </el-card>
    <!--更新cnpj信息-->
    <el-dialog
      :title="$t('mdfeTranslate.UpdateCnpjInformation')"
      :visible.sync="showUpdateInformationWindow"
      width="700px"
      :modal-append-to-body="true"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="5%"
    >
      <div v-if="estabelecimento">
        <el-form ref="estabelecimento" :model="estabelecimento">
          <el-row :gutter="10">
            <template
              v-for="(item, index) in estabelecimento.inscricoes_estaduais"
            >
              <template>
                <el-col :key="index + 'sigla'" :span="24">
                  <el-form-item label="sigla：" class="mb-0">
                    <span>{{ item.estado.sigla }}</span>
                  </el-form-item>
                </el-col>
                <el-col :key="index + 'inscricao_estadual'" :span="24">
                  <el-form-item
                    label="inscricao_estadual："
                    :prop="`inscricoes_estaduais.${index}.inscricao_estadual`"
                    :rules="{ required: true, validator: inscricoesEstaduais, trigger: ['blur','change']}"
                  >
                    <el-input v-model="item.inscricao_estadual" :disabled="!item.ativo" />
                  </el-form-item>
                </el-col>
              </template>
            </template>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showUpdateInformationWindow = false">{{ $t('collectionCenter.close') }}</el-button>
        <el-button size="small" type="primary" @click="confirmSaveNewData">{{ $t('collectionCenter.Confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight';
import { getCnpjInfo, getNewestCnpjInfo, updateCnpjInfo } from '@/api/invoiceCenter';
import { getUserIdAndNameObj } from '@/enums/storageEnum';

export default {
  name: 'CNPJ',
  mixins: [estimateTableHeight],
  data() {
    const inscricoesEstaduais = async(rule, value, callback) => {
      const reg = /^\d+$/;
      if (!value) {
        return callback(new Error(this.$t('collectionCenter.notNull'))); // 不能为空
      } else {
        if (!reg.test(value)) {
          return callback(new Error(this.$t('mdfeTranslate.OnlyNumbersCanBeEntered'))); // 只能输入数字
        } else {
          return callback();
        }
      }
    };
    return {
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          cnpj: ''
        }
      },
      createUser: [],
      tableData: [],
      total: 0,
      showUpdateInformationWindow: false,
      informationData: null,
      estabelecimento: null,
      inscricoesEstaduais
    };
  },
  created() {
    this.createUser = getUserIdAndNameObj();
    this.getTable();
  },
  methods: {
    // 搜索
    search() {
      this.queryForm.pageNumber = 1;
      this.getTable();
    },
    // 重置
    onReset() {
      this.queryForm.params.cnpj = '';
      this.getTable();
    },
    // 获取数据
    getTable() {
      getCnpjInfo(this.queryForm).then(res => {
        if (res.code === 200) {
          res.data.records.map(item => {
            if (item.responseData) {
              item.responseDataNew = JSON.stringify(JSON.parse(item.responseData), null, 2);
              item.responseDataEdit = JSON.parse(item.responseData);
            }
          });
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    // 更新cnpj信息
    updateInformation(row) {
      this.informationData = JSON.parse(JSON.stringify(row));
      this.estabelecimento = JSON.parse(JSON.stringify(row.responseDataEdit.estabelecimento));
      this.showUpdateInformationWindow = true;
    },
    // 确认更新cnpj信息
    confirmSaveNewData() {
      this.$refs['estabelecimento'].validate(valid => {
        if (valid) {
          this.informationData.responseDataEdit.estabelecimento = this.estabelecimento;
          this.$confirm(this.$t('mdfeTranslate.sureUpdateCnpjInformation'), this.$t('GlobalSetObj.tips'), {
            confirmButtonText: this.$t('GlobalSetObj.determine'), // '确定',
            cancelButtonText: this.$t('GlobalSetObj.cancel'), // '取消',
            type: 'warning'
          }).then(() => {
            const params = {
              cnpj: this.informationData.cnpj,
              responseData: JSON.stringify(this.informationData.responseDataEdit),
              id: this.informationData.id
            };
            updateCnpjInfo(params).then(res => {
              if (res.code === 200) {
                this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
                this.getTable();
                this.informationData = null;
                this.showUpdateInformationWindow = false;
              }
            });
          });
        }
      });
    },
    // 获取最新信息
    getNewInformation(row) {
      getNewestCnpjInfo(row.cnpj).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
          this.getTable();
        }
      });
    },
    // 翻页
    getCurrentTable(val) {
      this.queryForm.pageNumber = val;
      this.getTable();
    },
    // 改变每页显示数量
    getSizeTable(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getTable();
    }
  }
};
</script>

<style scoped>
.paramsStyle {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.mb-0 {
  margin-bottom: 0;
}
</style>
